import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

// Components
import SVG from 'components/widgets/icons/svg';
import Tooltip from 'components/widgets/overlays/tooltip';


export default function InvoiceLink({ invoiceId, ...props }) {
  return (
    <Link to={`/accounting/invoices/${invoiceId}`} {...props}>
      <Tooltip title="View invoice" className="inline-block">
        <SVG src="svg/invoice-list.svg" className="invoice" />
      </Tooltip>
    </Link>
  );
}

InvoiceLink.propTypes = {
  invoiceId: PropTypes.number
};



// WEBPACK FOOTER //
// ./app/components/widgets/icons/link-icons/invoice-link.js